import React from 'react';
import { Link } from 'react-router-dom';
import './WhyChooseUs.css';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <polyline points="9,12 11,14 15,10"/>
      </svg>
    ),
    title: 'Quality Guaranteed',
    description: 'Every project meets the highest industry standards with our comprehensive quality assurance process.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12,6 12,12 16,14"/>
      </svg>
    ),
    title: 'On-Time Delivery',
    description: 'We understand time is money. Our project management ensures deadlines are always met.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 00-3-3.87"/>
        <path d="M16 3.13a4 4 0 010 7.75"/>
      </svg>
    ),
    title: 'Expert Team',
    description: 'Our skilled professionals bring decades of combined experience to every project.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
      </svg>
    ),
    title: 'Transparent Pricing',
    description: 'No hidden costs or surprises. Detailed quotes with clear breakdowns from day one.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
        <polyline points="3.27,6.96 12,12.01 20.73,6.96"/>
        <line x1="12" y1="22.08" x2="12" y2="12"/>
      </svg>
    ),
    title: 'Innovative Solutions',
    description: 'We embrace modern construction technologies and sustainable building practices.'
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
        <line x1="4" y1="22" x2="4" y2="15"/>
      </svg>
    ),
    title: 'Fully Insured',
    description: 'Complete peace of mind with comprehensive insurance coverage on all projects.'
  }
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose" id="about">
      <div className="why-choose__container">
        <div className="why-choose__content">
          <div className="why-choose__left">
            <span className="section-label">Why Choose Us</span>
            <h2 className="section-title">
              Designing <span className="text-accent">Future</span> With Excellence
            </h2>
            <p className="why-choose__description">
              With over 10 years of experience, we've earned 
              our reputation for exceptional craftsmanship and reliable service. Our 
              commitment to quality and customer satisfaction sets us apart.
            </p>
            
            <div className="why-choose__image-feature">
              <img src="/images/about/interior-courtyard.jpeg" alt="Our Quality Work" loading="lazy" decoding="async" />
              <div className="why-choose__image-badge">
                <span className="badge-number">1000+</span>
                <span className="badge-text">Projects Completed</span>
              </div>
            </div>
            
            <div className="why-choose__highlight">
              <div className="why-choose__highlight-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                  <polyline points="22,4 12,14.01 9,11.01"/>
                </svg>
              </div>
              <div className="why-choose__highlight-text">
                <strong>Trusted by 1000+ Homeowners</strong>
                <span>Join our growing family of satisfied clients</span>
              </div>
            </div>
            
            <Link to="/plan" className="btn btn--primary">
              <span>Start Your Project</span>
              <svg className="btn__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M5 12h14M12 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
          
          <div className="why-choose__right">
            <div className="why-choose__grid">
              {features.map((feature, index) => (
                <div 
                  className="feature-card" 
                  key={index}
                >
                  <div className="feature-card__icon">
                    {feature.icon}
                  </div>
                  <h3 className="feature-card__title">{feature.title}</h3>
                  <p className="feature-card__description">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative background */}
      <div className="why-choose__bg-pattern"></div>
    </section>
  );
};

export default WhyChooseUs;

